import React, { useEffect, useState, useRef } from "react";

// import { getCarousel } from "../../Actions/carouselAction";
// import { useDispatch, useSelector } from "react-redux";
// import LoaderOnlySpinner from "./loaderOnlySpinner";
import ExclamationIcon from "../../assets/img/exclamation-mark-icon.svg";
const DeletePopup = React.forwardRef((props, ref) => {
  //   const dispatch = useDispatch();

  const { showModalBox, record, title, description } = props;
  //   const [isLoading, setIsLoading] = useState(false);

  //   useEffect(() => {
  //     const fetchData = async () => {

  //       dispatch(getCarousel(record));
  //     };

  //     fetchData();
  //   }, []);

  //   const storeCarouselData = useSelector((state) => state.carousel);
  //   //const dispatch = useDispatch();
  //   const { carouselData, loading, error } = storeCarouselData;

  //   const [sliderData, setSliderData] = useState([]);

  //     useEffect(() => {

  //       console.log(carouselData.data);

  //     if (typeof carouselData.data !== "undefined" && carouselData.data !== null) {

  //       let arr = [];

  //       Object.entries(carouselData.data).map(([key, value]) => {

  //         arr.push(value.preview_key);

  //       });

  //       // Object.entries(carouselData.data).map()
  //        setSliderData(arr);
  //     }else{
  //       setSliderData([]);
  //     }
  //   }, [carouselData, storeCarouselData]);

  //   useEffect(() => {
  //     if (typeof loading !== "undefined" && loading !== null) {
  //       if(loading === true){
  //         setIsLoading(true);
  //         }else{ setIsLoading(false);}

  //     }
  //   }, [carouselData]);

  const closePopupHandler = () => {
    props.closePopup();
  };

  const proceedHandler = (e) => {
    e.preventDefault();
    props.proceedHandler();
  };

  return (
    <>
      <div
        className={
          "dashboard custom-modal-dialog " +
          (showModalBox === 1 ? "show" : "hidden")
        }
        onClick={closePopupHandler}
      >
        <div
          className="modal-wrapper justify-content-center"
          onClick={(e) => {
            // do not close modal if anything inside modal content is clicked
            e.stopPropagation();
          }}
        >
          <div
            className="modal-content p-4 no-scroll"
            style={{ maxWidth: "370px" }}
          >
            <div className="text-left">
              <img src={ExclamationIcon} alt="" />
              <h5 className="mt-3">{title}</h5>
              <p className="text-muted">{description}</p>
            </div>
            <div className="row">
              <div className="col-md-12 d-flex justify-content-between">
                <button
                  className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2"
                  onClick={closePopupHandler}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger btn-lg btn-block mt-3"
                  onClick={(e) => proceedHandler(e)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default DeletePopup;
